import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { parseQuery } from '@calendly/http-tools'

import { inviteeLanded, setInviteeFrom } from 'actions/analytics'

const Analytics = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(inviteeLanded())

    const query = parseQuery(window.location.search)
    const source = query.from
    if (source) dispatch(setInviteeFrom(source))
  }, [dispatch])

  return null
}

export default Analytics
